const $ = jQuery.noConflict();
const header = document.querySelector('.main-header');
const logo = document.querySelector('.main-header__logo');
const whiteLogo = document.querySelector('.main-header__white_logo');

const transprentHeader = () => {
    header.classList.add('hero-display-header');
	if (header.classList.contains('sticky')) {
		header.classList.remove('sticky');
        whiteLogo.style.display = 'block';
        logo.style.display = 'none';
    }

    if ($('#page > .content-wrapper > .block-hero-display').length > 0) {
        const headerHeight = $('.main-header').outerHeight(true);
        $('#page > .content-wrapper > .block-hero-display').css("margin-top","-"+headerHeight+"px");
    }
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		transprentHeader();
	},
	loaded() {},
	resized() {},
	scrolled() {
        if (window.scrollY > 0) {
            header.classList.add('sticky');
            whiteLogo.style.display = 'none';
            logo.style.display = 'block';
        } else {
            header.classList.remove('sticky');
            whiteLogo.style.display = 'block';
            logo.style.display = 'none';   
        }

    },
	keyDown() {},
	mouseUp() {},
};
export default controller;
